import { render, staticRenderFns } from "./menu-content.vue?vue&type=template&id=6b16e5bd&scoped=true&"
import script from "./menu-content.vue?vue&type=script&lang=js&"
export * from "./menu-content.vue?vue&type=script&lang=js&"
import style0 from "./menu-content.vue?vue&type=style&index=0&id=6b16e5bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16e5bd",
  null
  
)

export default component.exports